module.exports = __webpack_public_path__ + "a56d109ba7caae7b03b0db3ebeb8b393.svg";